function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.53 3.59a.75.75 0 00-1.06 0l-9.88 9.88a.75.75 0 000 1.06l1.07 1.068A2.75 2.75 0 018.4 19.34l1.07 1.07a.75.75 0 001.06 0l9.88-9.879a.75.75 0 000-1.06l-1.07-1.07a2.75 2.75 0 01-3.743-3.743L14.53 3.59zm-2.12-1.06a2.25 2.25 0 013.182 0l1.171 1.172c.511.51.42 1.227.162 1.66a1.25 1.25 0 001.713 1.713c.433-.257 1.15-.349 1.66.162L21.47 8.41a2.251 2.251 0 010 3.182l-9.878 9.878a2.251 2.251 0 01-3.182 0L7.238 20.3c-.51-.51-.42-1.229-.162-1.66a1.25 1.25 0 00-1.713-1.714c-.433.257-1.15.348-1.66-.163L2.53 15.591a2.25 2.25 0 010-3.182l9.88-9.879z"
});

function SvgTicketType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTicketType;